import moment from "moment"
import Service from "../../../Services/index";

const Billing = {
    namespaced: true,
    state: {
        billings: [],
        billingCounts: {
            all: 0,
            pending: 0,
            paid: 0,
            approved: 0
        },
        select_all : false,
        search: {
            seller_id: null,
            billing_status_id: null,
            start_date: null,
            end_date: null,
            no : '',
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        create_billing : []
    },
    mutations: {
        SET_BILLINGS: (state, res) => {
            state.billings = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        SET_STATUS: (state, status) => {
            state.search.billing_status_id = status
        },
        SET_BILLING_COUNTS: (state, data) => {
            state.billingCounts = data
        },
        SET_SEARCH: (state, search) => {
            state.search = {
                ...state.search,
                ...search
            };
            state.select_all = false;
        },
        CLEAR_SEARCH :(state)=>{
            state.search = {
                seller_id: null,
                billing_status_id: null,
                start_date: null,
                end_date: null,
                no : '',
            }
        },
        SET_SELECT_ALL:(state,res)=>{
            state.select_all = res;
        },
    },
    actions: {
        setBillings({ state, commit }) {
            return Service.Billing.getBillings({
                page: state.dataPaginate.current_page,
                ...state.search
            })
                .then(data => {
                    commit("SET_BILLINGS", data)
                    // commit('SET_SELECT_ALL',false);
                    commit("SET_BILLING_COUNTS", data.counting)
                })
        },
        showBillingById({commit},id){
            return Service.Billing.getBillingById(id)
        },
        setBillingCounts({ commit }) {
            return Service.Billing.getBillingCounts()
                .then(data => {
                    commit("SET_BILLING_COUNTS", data)
                })
        },
        setStatus({ commit }, status) {
            const billingStatus = status
                ? status
                : ''

            commit("SET_STATUS", billingStatus)
        },
        setSearch({ commit }, search) {
            commit("SET_SEARCH", search)
        },
        createBilling({ state, commit, rootState }, receivable) {
            let data = {
                data : receivable
            }
            return Service.Billing.createBilling(data)
        },
        updateBilling({commit}, {id,data}){
            return Service.Billing.updateBilling(id,data);
        },
        approveBilling(context, billingId) {
            return Service.Billing.changeBillingStatus(billingId, {
                billing_status_id: 3
            })
        },
        cancelBilling({ commit }, id){
            return Service.Billing.deleteBilling(id);
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        getBillingAll(){
            return Service.Billing.getBillingAll();
        },
        selectBillingAll({commit,state},data){
            // data.page = state.dataPaginate.current_page;
            data.start_index = state.dataPaginate.current_page;
            return Service.Billing.selectBillingAll(data);
        },
        setSelectAll({commit},data){
            commit('SET_SELECT_ALL',data)
        },
        printMultiBilling({commit},id){
            return Service.Billing.printMultiBilling(id);
        }
    }
};

export default Billing
